import {
  createPlugin,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import {} from './';
import { DatadogDashboardApiRef, DatadogDashboardClient } from './apis';
export const datadogDashboardPlugin = createPlugin({
  id: 'datadog-dashboard',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: DatadogDashboardApiRef,
      deps: {
        configApi: configApiRef,
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory({ configApi, discoveryApi, fetchApi }) {
        return new DatadogDashboardClient({
          discoveryApi,
          fetchApi,
          baseUrl: configApi.getOptionalString('datadogdashboard.baseUrl'),
        });
      },
    }),
  ],
});

export const DatadogDashboardPage = datadogDashboardPlugin.provide(
  createRoutableExtension({
    name: 'DatadogDashboardPage',
    component: () =>
      import('./components/DatadogDashboardComponent').then(m => m.DatadogDashboardComponent),
    mountPoint: rootRouteRef,
  }),
);
